import { useFilterPackageActivityContext } from "./filter-package-activity.context";

export function FilterPackageActivity() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterPackageActivityContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}